import React, { useEffect, useState } from 'react';
import SkeletonJig from '../components/skeletons/SkeletonJig';

export const Learn = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [hovered, setHovered] = useState(null);

  useEffect(() => {
    // Simulate loading delay (remove this in your actual implementation)
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const linkStyle = (key) => ({
    color: hovered === key ? '#f4a300' : '#333',
    textDecoration: 'none',
    transition: 'color 0.2s ease',
  });

  const onEnter = (key) => () => setHovered(key);
  const onLeave = () => setHovered(null);

  return (
    <>
      <br />
      <div className='content'>
        {isLoading ? (
          <SkeletonJig />
        ) : (
          <>
            <div className='box'>
              <p>
                Over the years, I’ve developed repeatable systems for segmented
                pen making. These are the resources available for those who want
                to learn.
              </p>
            </div>

            <div style={{ textAlign: 'center' }}>
              <img
                src='/images/PenSegmenting.png'
                alt='The Art of Pen Segmenting book cover'
                style={{
                  maxWidth: '220px',
                  width: '100%',
                  height: 'auto',
                }}
              />
            </div>
            <br />
            <br />

            <div className='box'>
              <h2>The Art Of Pen Segmenting</h2>
              <p>A practical guide from the shop</p>

              <div className='socialIcon'>
                <ul className='list-unstyled'>
                  <li>
                    <a
                      href='https://www.amazon.com/dp/B0GND4G87Q'
                      target='_blank'
                      rel='noopener noreferrer'
                      onMouseEnter={onEnter('amazon')}
                      onMouseLeave={onLeave}
                      style={linkStyle('amazon')}
                    >
                      Available in eBook &amp; Paperback on Amazon
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className='box'>
              <h2>Pen Segmenting on Udemy</h2>
              <div className='socialIcon'>
                <ul className='list-unstyled'>
                  <li>
                    <a
                      href='https://www.udemy.com/course/pen-segmenting-tools-and-jigs-part-1'
                      target='_blank'
                      rel='noopener noreferrer'
                      onMouseEnter={onEnter('udemy1')}
                      onMouseLeave={onLeave}
                      style={linkStyle('udemy1')}
                    >
                      Part 1
                    </a>
                  </li>
                  <li>
                    <a
                      href='https://www.udemy.com/course/part-2-pen-segmenting-with-basic-tools-and-jigs'
                      target='_blank'
                      rel='noopener noreferrer'
                      onMouseEnter={onEnter('udemy2')}
                      onMouseLeave={onLeave}
                      style={linkStyle('udemy2')}
                    >
                      Part 2
                    </a>
                  </li>
                  <li>
                    <a
                      href='https://www.udemy.com/course/part-3-pen-segmenting-with-basic-tools-and-jigs'
                      target='_blank'
                      rel='noopener noreferrer'
                      onMouseEnter={onEnter('udemy3')}
                      onMouseLeave={onLeave}
                      style={linkStyle('udemy3')}
                    >
                      Part 3
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className='box'>
              <h2>YouTube Segmenting Videos</h2>
              <p>Free shop demonstrations and builds</p>

              <div className='socialIcon'>
                <ul className='list-unstyled'>
                  <li>
                    <a
                      href='https://www.youtube.com/channel/UCVdwaT1LF4iv6q5okes29tA'
                      target='_blank'
                      rel='noopener noreferrer'
                      onMouseEnter={onEnter('youtube')}
                      onMouseLeave={onLeave}
                      style={linkStyle('youtube')}
                    >
                      Watch on YouTube
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <br />
          </>
        )}
      </div>
    </>
  );
};

export default Learn;
